<template>
    <TableFilter :scheme-type="enumDef.filterSchemeType.BuyerExchangeRevolvingPutOptions"
                 :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
		<!-- debtor -->
		<div class="filter_item">
			<div class="filter_head">{{$t("common.debtor")}}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="debtorName"
						ref="filter_debtorName"
			></TextFilter>
			<TextFilter :label-text="$t('common.riskScore')"
						  column-name="debtorCreditsafeRating"
						  ref="filter_debtorCreditsafeRating"
			></TextFilter>
			<IndustryFilter :label-text="$t('common.industry')"
							column-name="debtorIndustryNaceCode"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="$t('common.country')"
						   :company-type="enumDef.companyType.DebtorCompany"
						   column-name="debtorCountry"
						   ref="filter_debtorCountry">
			</CountryFilter>
			<FromToFilter v-if="ratingConfig && ratingConfig.showRating1"
						  :label-text="ratingConfig.nameRating1"
						  column-name="debtorRating1"
						  ref="filter_debtorRating1"
			></FromToFilter>
			<FromToFilter v-if="ratingConfig && ratingConfig.showRating2"
						  :label-text="ratingConfig.nameRating2"
						  column-name="debtorRating2"
						  ref="filter_debtorRating2"
			></FromToFilter>
			<FromToFilter v-if="ratingConfig && ratingConfig.showRating3"
						  :label-text="ratingConfig.nameRating3"
						  column-name="debtorRating3"
						  ref="filter_debtorRating3"
			></FromToFilter>
		</div>
		<!-- seller -->
		<div class="filter_item">
			<div class="filter_head">{{$t("common.supplier")}}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="sellerName"
						ref="filter_sellerName"
			></TextFilter>
			<TextFilter :label-text="$t('common.riskScore')"
						  column-name="sellerCreditsafeRating"
						  ref="filter_sellerCreditsafeRating"
			></TextFilter>
			<IndustryFilter :label-text="$t('common.industry')"
							column-name="sellerIndustryNaceCode"
							ref="filter_sellerIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="$t('common.country')"
						   column-name="sellerCountry"
						   ref="filter_sellerCountry">
			</CountryFilter>
			<FromToFilter v-if="ratingConfig && ratingConfig.showRating1"
						  :label-text="ratingConfig.nameRating1"
						  column-name="sellerRating1"
						  ref="filter_sellerRating1"
			></FromToFilter>
			<FromToFilter v-if="ratingConfig && ratingConfig.showRating2"
						  :label-text="ratingConfig.nameRating2"
						  column-name="sellerRating2"
						  ref="filter_sellerRating2"
			></FromToFilter>
			<FromToFilter v-if="ratingConfig && ratingConfig.showRating3"
						  :label-text="ratingConfig.nameRating3"
						  column-name="sellerRating3"
						  ref="filter_sellerRating3"
			></FromToFilter>
		</div>
		<!-- data base 12Month -->
		<div class="filter_item">
			<div class="filter_head">{{$t("investor.exchange.filter.riskAnalysis.groupTitle")}}</div>
			<FromToFilter :label-text="$t('common.sum')"
						  column-name="assessmentQuantity"
						  field-type="I"
						  ref="filter_assessmentQuantity"
			></FromToFilter>
			<FromToFilter :label-text="$t('common.latePaymentDays')"
						  column-name="assessmentLatePaymentDays"
						  ref="filter_assessmentLatePaymentDays"
			></FromToFilter>
      <FromToFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.currentOutstanding')"
                    column-name="assessmentOverdueOutstanding"
                    ref="filter_assessmentOverdueOutstanding"
      ></FromToFilter>
      <BooleanFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.directPay')"
                     column-name="assessmentDirectPay"
                     ref="filter_assessmentDirectPay"
      ></BooleanFilter>
		</div>
		<!-- Option -->
		<div>
			<div class="filter_head">{{$t("common.revolvingPutOption")}}</div>
			<div class="flex">
				<div class="filter_item filter_item_xl">
					<DateFilter :label-text="$t('revolvingPutOption.optionStart')"
								column-name="startDate"
								ref="filter_startDate"
					></DateFilter>
					<DateFilter :label-text="$t('revolvingPutOption.optionEnd')"
								column-name="endDate"
								ref="filter_endDate"
					></DateFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.discount.withPercent')"
								  column-name="discountRate"
								  ref="filter_discountRate"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.revolvingLine')"
								  column-name="saleLimit"
								  ref="filter_saleLimit"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.estimatedSalesVolume')"
								  column-name="estimatedSalesVolume"
								  ref="filter_estimatedSalesVolume"
					></FromToFilter>
				</div>
				<div class="filter_item filter_item_xl">
					<CountryFilter :label-text="$t('common.applicableLaw')"
								   :companyType="enumDef.companyType.DebtorCompany"
								   column-name="applicableLaw"
								   ref="filter_applicableLaw"
					></CountryFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.paymentTerms')"
								  column-name="paymentTerms"
								  field-type="I"
								  ref="filter_paymentTerms"
					></FromToFilter>
					<EnumFilter :label-text="$t('common.assignmentType')"
								column-name="disclosed"
								:enum-def="enumDef.disclosedType"
								field-type="B"
								ref="filter_disclosed"
					></EnumFilter>
				</div>
			</div>
		</div>
    </TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

import EnumFilter from "@/components/newFilter/EnumFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import IndustryFilter from "@/components/newFilter/IndustryFilter.vue";
import CountryFilter from "@/components/newFilter/CountryFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import TableFilter from "@/components/newFilter/TableFilter";
import BooleanFilter from "@/components/newFilter/BooleanFilter";

export default {
    props: {
        ratingConfig: Object
    },
    components: {
		TableFilter,
		DateFilter,
		IndustryFilter,
		TextFilter,
		EnumFilter,
		FromToFilter,
		CountryFilter,
    BooleanFilter
	},
    data() {
        return {
            enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>